import {makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        maxWidth: '36ch',
        backgroundColor: theme.palette.background.paper,
      },
      inline: {
        display: 'inline',
      },
      notiWrapper:{
       "& .MuiDivider-inset":{
        marginLeft: '0',
       },
       "& .MuiTypography-body1":{
         fontSize:'12px',
       },
      },
      txtClrGray:{
        color:'#adadad',
        fontSize:'8px !important',
      },
}));

export default  useStyles;